export default {
    apiBase: "https://api.thruxtonracing.co.uk/"
    //apiBase: "https://localhost:5001/"
}